module.exports = __webpack_public_path__ + "media/images/black_history_month/bg-shape-lemongreen-ladyfinger-2e9dfe341e02dc30be60795eedca821e.svg";